import { render, staticRenderFns } from "./Payslips.vue?vue&type=template&id=4571eb65"
import script from "./Payslips.vue?vue&type=script&lang=js"
export * from "./Payslips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4571eb65')) {
      api.createRecord('4571eb65', component.options)
    } else {
      api.reload('4571eb65', component.options)
    }
    module.hot.accept("./Payslips.vue?vue&type=template&id=4571eb65", function () {
      api.rerender('4571eb65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payslips/Payslips.vue"
export default component.exports